<template>
    <div>

        <div v-if="error.message">{{ error.message }}</div>

        <div v-if="loading" class="text-center py-16">Loading...</div>

    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {

    name: 'Home',

    computed: {

        ...mapState(['loading', 'error'])
    },

    methods: {

        ...mapActions(['startVa']),

        getHomeVa () {
            let code = (window.env && window.env.home_va_code) ? window.env.home_va_code : '';
            return { code };
        }
    },

    created () {

        let va = this.getHomeVa();

        this.startVa({ va });
    }

}
</script>
